import { images } from '../constants';

const process = [  
    {
        id: 1,
        image: images.step1,
        title: 'Initial Consultation',
        content: 'Begin with an initial consultation to understand your garden or landscaping vision, preferences, and requirements.',
    },
    {
        id: 2,
        image: images.step2,
        title: 'Design Planning',
        content: 'Professional design and planning of your garden or landscape layout, considering factors like space and sunlight.',
    },
    {
        id: 3,
        image: images.step3,
        title: 'Planting Installation',
        content: 'Expert planting of trees, shrubs, flowers, and installation of hardscaping features, following the design plan.',
    },
    {
        id: 4,
        image: images.step4,
        title: 'Maintenance Guidance',
        content: 'Receive expert guidance on garden and landscape maintenance to ensure long-term health of your outdoor space.',
    },
    {
        id: 5,
        image: images.step5,
        title: 'Quality Check',
        content: 'Thorough inspection and testing to ensure the health, integrity, and quality of your garden or landscape features.',
    },
    {
        id: 6,
        image: images.step6,
        title: 'Client Satisfaction',
        content: 'Ensuring your satisfaction with the completed project through thorough inspection and final approval.',
    },
];

export default process;